import {
  Combobox,
  ComboboxCollection,
  ComboboxContent,
  ComboboxInput,
  ComboboxItem,
  ComboboxList,
} from '@components/ui/combobox';
import type { Comparator } from '@domain/schemas/filters.schema';
import clsx from 'clsx';

import { APP_FOCUS_RING_OVERRIDE, COMPARATOR_LABELS } from '../constants';

interface ComparatorSelectorProps {
  comparators: Comparator[];
  value: Comparator | '';
  onChange: (value: Comparator) => void;
  disabled?: boolean;
}

export function ComparatorSelector({ comparators, value, onChange, disabled }: ComparatorSelectorProps) {
  const items = comparators.map((c) => ({ label: COMPARATOR_LABELS[c], value: c }));
  const selected = items.find((i) => i.value === value) ?? null;

  return (
    <Combobox
      items={items}
      value={selected}
      onValueChange={(item) => item && onChange(item.value as Comparator)}
      disabled={disabled}
    >
      <ComboboxInput
        className={clsx('border-info-300 h-10 w-40 shrink-0 overflow-hidden shadow-none', APP_FOCUS_RING_OVERRIDE)}
        placeholder="EQUALS"
        readOnly
      />

      <ComboboxContent>
        <ComboboxList>
          <ComboboxCollection>
            {(item) => (
              <ComboboxItem key={item.value} value={item}>
                {item.label}
              </ComboboxItem>
            )}
          </ComboboxCollection>
        </ComboboxList>
      </ComboboxContent>
    </Combobox>
  );
}
